export const PredictDiffSign = {
  Plus: 'plus',
  Zero: 'zero',
  Minus: 'minus',
  from: (integer: number) => {
    if (integer === 0) {
      return PredictDiffSign.Zero;
    }
    if (integer > 0) {
      return PredictDiffSign.Plus;
    }
    return PredictDiffSign.Minus;
  }
} as const;


export type PredictDiffSign =
  (typeof PredictDiffSign)[keyof Omit<typeof PredictDiffSign, 'from'>];
